export function useRandomizedBackground ({ storage, document }) {
  const backgroundMap = new Map();
  backgroundMap.set('wollam', [
    require('@/assets/wollam/background-01.png'),
    require('@/assets/wollam/background-02.png'),
    require('@/assets/wollam/background-03.png'),
    require('@/assets/wollam/background-04.png')
  ]);
  backgroundMap.set('default', [
    require('@/assets/background-excavator.jpg'),
    require('@/assets/background-marker.jpg'),
    require('@/assets/background-offshore.png'),
    require('@/assets/background-worker.jpg')
  ]);

  // Background cycling
  function getBackgroundImage (template) {
    template = (template || '').toLowerCase();
    const templateKey = backgroundMap.has(template) ? template : 'default';
    const backgrounds = backgroundMap.get(templateKey);
    const count = backgrounds.length;
    let index;
    if (storage) {
      index = parseInt(storage.getItem('login-bg-index'));
      index = !isNaN(index)
        ? ++index % count
        : 0;
      storage.setItem('login-bg-index', index);
    } else {
      index = Math.floor(Math.random() * 10) % count;
    }
    return backgrounds[index];
  }

  return {
    init: function (template) {
      document.body.style.backgroundImage = "url('" + getBackgroundImage(template) + "')";
    }
  };
}
